mutation UpsertMembers(
  $workspaceId: ID!
  $members: [MemberInput]!
) {
  members: createAndUpdateMembers(
    workspaceId: $workspaceId
    members: $members
  ) {
    id
  }
}
